export default function Check({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1178 5.21368C14.5521 5.55489 14.6275 6.18355 14.2863 6.61782L9.10822 13.2081C8.53966 13.9317 7.43954 13.9194 6.88738 13.1832L4.2 9.6C3.86863 9.15817 3.95817 8.53137 4.4 8.2C4.84183 7.86863 5.46863 7.95817 5.8 8.4L8.01845 11.3579L12.7137 5.38218C13.0549 4.9479 13.6835 4.87247 14.1178 5.21368Z"
        fill="currentColor"
      />
    </svg>
  )
}
